import { connect } from '../../../../common/react-redux';
import OutstandingQuizzesModal from './presenter';
import { OUTSTANDING_QUIZZES_MODAL } from '@instructure/quiz-common';
import { closeModal } from '../../../../common/actions/modal';
import { submitOutstandingQuizSession } from '../../../api/quizSessions';
export function mapStateToProps(state, ownProps) {
  return {
    open: state.getIn(['modal', 'isOpen']) === OUTSTANDING_QUIZZES_MODAL
  };
}
export var mapDispatchToProps = {
  submitOutstandingQuizSession: submitOutstandingQuizSession,
  closeModal: closeModal
};
export default connect(mapStateToProps, mapDispatchToProps)(OutstandingQuizzesModal);